var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const SPLIT_ORDER = "SPLIT_ORDER";
const RECORD_CASE_CHANGED_INFO_SWITCH = "RECORD_CASE_CHANGED_INFO_SWITCH";
const GET_CHANGED_INFO = "GET_CHANGED_INFO";
const REQUEST_CHECK_FILE = "REQUEST_CHECK_FILE";
const HIGHLIGHT_PID = "HIGHLIGHT_PID";
let isInitEvent = false;
const print = console;
const promiseMap = {};
const onMessage = (event) => {
  var _a, _b, _c, _d, _e;
  print.log(event, "message event");
  if (!event.data || !event.data.action)
    return;
  const { action, id, value } = event.data;
  const { status, message } = value || {};
  (_a = promiseMap[id]) == null ? void 0 : _a.params;
  if (!status)
    (_c = (_b = promiseMap[id]) == null ? void 0 : _b.reject) == null ? void 0 : _c.call(_b, `\u9177\u5BB6\u4E50\u6307\u4EE4${action}\u6570\u636E\u8FD4\u56DE\u5F02\u5E38\uFF1A${message || ""}`);
  (_e = (_d = promiseMap[id]) == null ? void 0 : _d.resolve) == null ? void 0 : _e.call(_d, value);
  promiseMap[id] = null;
};
const postMessage = (action, params, sequenceId) => {
  if (window.parent === window) {
    const message = "\u672A\u68C0\u6D4B\u5230\u8BBE\u8BA1\u8F6F\u4EF6\uFF0C\u65E0\u6CD5\u4F7F\u7528\u8BBE\u8BA1\u8F6F\u4EF6\u7684\u76F8\u5173\u529F\u80FD";
    return Promise.reject(message);
  }
  if (!isInitEvent) {
    window.addEventListener("message", onMessage);
    isInitEvent = true;
  }
  const id = sequenceId;
  return new Promise((resolve, reject) => {
    print.log("postMessage", { action, id, value: params });
    window.parent.postMessage({ action, id, value: params }, "*");
    promiseMap[id] = { resolve, reject, action, params };
  });
};
const actions = {
  splitOrder: SPLIT_ORDER,
  recordCaseChangedInfoSwitch: RECORD_CASE_CHANGED_INFO_SWITCH,
  getChangedInfo: GET_CHANGED_INFO,
  requestCheckFile: REQUEST_CHECK_FILE,
  highlightPid: HIGHLIGHT_PID
};
const kjlRequest = Object.entries(actions).reduce((prev, [key, action]) => {
  return __spreadProps(__spreadValues({}, prev), {
    [key]: (params, sequenceId) => postMessage(action, params, sequenceId)
  });
}, {});
export { kjlRequest };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/external/kujiale/initKujiale.js